// extracted by mini-css-extract-plugin
export default {"maincontainer":"logoutdiv_maincontainer__LYnQh"};